var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-container" },
    [
      _c(
        "div",
        { staticClass: "hx-breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { "separator-class": "el-icon-arrow-right" } },
            [
              _c("el-breadcrumb-item", [_vm._v("商城管理")]),
              _c("el-breadcrumb-item", [_vm._v("商城订单")]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "hx-form-container box-shadow" },
        [
          _c(
            "el-form",
            {
              ref: "listForm",
              attrs: { model: _vm.listParams, "label-width": "100px" },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "订单状态：", prop: "orderStatus" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "请选择订单状态",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.listParams.orderStatus,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listParams, "orderStatus", $$v)
                                },
                                expression: "listParams.orderStatus",
                              },
                            },
                            _vm._l(_vm.orderStatusList, function (item) {
                              return _c("el-option", {
                                key: item.title,
                                attrs: { label: item.title, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 16 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "日期查询：", prop: "timeInterval" },
                        },
                        [
                          _c("date-picker-group", {
                            model: {
                              value: _vm.listParams.timeInterval,
                              callback: function ($$v) {
                                _vm.$set(_vm.listParams, "timeInterval", $$v)
                              },
                              expression: "listParams.timeInterval",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "用户账号：", prop: "userAccount" } },
                        [
                          _c("el-input", {
                            attrs: {
                              size: "small",
                              placeholder: "请输入用户账号",
                            },
                            model: {
                              value: _vm.listParams.userAccount,
                              callback: function ($$v) {
                                _vm.$set(_vm.listParams, "userAccount", $$v)
                              },
                              expression: "listParams.userAccount",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "用户手机号：", prop: "phoneNumber" },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              size: "small",
                              placeholder: "请输入用户手机号",
                            },
                            model: {
                              value: _vm.listParams.phoneNumber,
                              callback: function ($$v) {
                                _vm.$set(_vm.listParams, "phoneNumber", $$v)
                              },
                              expression: "listParams.phoneNumber",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "primary" },
                              on: { click: _vm.loadTableData },
                            },
                            [_vm._v(" 查询 ")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.resetFields("listForm")
                                },
                              },
                            },
                            [_vm._v(" 重置 ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "hx-table-result",
        {
          attrs: { "page-info": _vm.pager, loading: _vm.tableLoading },
          on: {
            "page-current-change": _vm.handleCurrentChange,
            "page-size-change": _vm.handleSizeChange,
          },
        },
        [
          _c("div", { attrs: { slot: "action" }, slot: "action" }),
          _c("hx-table-result-col", [
            _c(
              "div",
              {
                staticClass: "wrap-table-info-display",
                staticStyle: { height: "32px" },
              },
              [
                _c("span", { staticClass: "table-info-display" }, [
                  _c("span", [_vm._v("总条数：")]),
                  _c("span", { staticClass: "alert-text ft16" }, [
                    _vm._v(_vm._s(_vm.pager.total)),
                  ]),
                ]),
              ]
            ),
          ]),
          _c(
            "el-table",
            {
              attrs: {
                slot: "content",
                data: _vm.tableData,
                "max-height": "800",
                border: "",
              },
              slot: "content",
            },
            [
              _c("el-table-column", {
                attrs: { width: "80", align: "center", label: "序号" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(
                              (_vm.pager.pageIndex > 1
                                ? (_vm.pager.pageIndex - 1) * _vm.pager.pageSize
                                : 0) +
                                scope.$index +
                                1
                            ),
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "userAccount",
                  align: "center",
                  label: "用户账号",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "orderDate",
                  align: "center",
                  label: "下单日期",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm._f("formatDate")(scope.row.orderDate)) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "goodsNumber",
                  align: "center",
                  label: "商品数量",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "orderAmount",
                  align: "center",
                  label: "订单金额(元)",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " ￥" +
                            _vm._s(
                              _vm._f("formatToFixed2")(scope.row.orderAmount)
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "orderStatusDisplay",
                  align: "center",
                  label: "订单状态",
                },
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.orderStatusValue === 2
                          ? _c(
                              "confirm-button",
                              {
                                staticStyle: { margin: "0 10px" },
                                attrs: {
                                  type: "text",
                                  title: "确认要发货吗？",
                                },
                                on: {
                                  confirmed: function ($event) {
                                    return _vm.deliverItem(scope.row.orderId)
                                  },
                                },
                              },
                              [_c("span", [_vm._v("发货")])]
                            )
                          : _vm._e(),
                        scope.row.orderStatusValue === 3
                          ? _c(
                              "confirm-button",
                              {
                                staticStyle: { margin: "0 10px" },
                                attrs: {
                                  type: "text",
                                  title: "确认要收货吗？",
                                },
                                on: {
                                  confirmed: function ($event) {
                                    return _vm.receiveItem(scope.row.orderId)
                                  },
                                },
                              },
                              [_c("span", [_vm._v("收货")])]
                            )
                          : _vm._e(),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.linkToDetailPage(scope.row.orderId)
                              },
                            },
                          },
                          [_vm._v(" 订单详情 ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }